var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-discount",class:`block-discount--${_vm.size}`},[_c('div',{staticClass:"block-discount__text white--text"},[_vm._v(_vm._s(_vm.percent)+_vm._s(_vm.$t('units.percent')))]),_c('v-icon',[_vm._v("mdi-bookmark")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }